import {text_mod_20, } from "../text/Text.js";
export const module20 = {
  title:
    "Вимова та правопис слів із дзвінкими й глухими приголосними звуками​​",
  questions: [
    {
      id: 1,
      onlyText: true,
      text: text_mod_20, },
    ]
  }
